import React, { useRef, useState, useEffect, Fragment } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import { TableCell, TableRow } from '@material-ui/core';

const SkeletonTable = ({
    size = 50,
    visibleRows = {},
    check = true,
    width = 150,
    height = 50,
    rows,
}) => {
    const containerRef = useRef(null);
    const [containerWidth, setContainerWidth] = useState(0);

    const BULK_ACTIONS_WIDTH = 50;
    const ALARM_WIDTH = 190;

    const smallTableCell = (index) => {
        return (
            <TableCell
                style={{ padding: 5, height: 30, width: BULK_ACTIONS_WIDTH }}
                width={BULK_ACTIONS_WIDTH}
                data-testid={
                    check
                        ? `skeleton-table-row-checkbox-${index}`
                        : `skeleton-table-row-alarm-${index}`
                }
            >
                <Skeleton variant="rect" height={height} />
            </TableCell>
        );
    };

    useEffect(() => {
        if (containerRef.current)
            setContainerWidth(containerRef.current.clientWidth);
    }, []);

    const hasAlarm = Object.entries(visibleRows).some(
        ([key, value]) => value && key === 'alarm'
    );

    const totalVisibleRows = Object.entries(visibleRows).filter(
        ([key, value]) => value && key !== 'alarm'
    ).length;

    const totalWidth = totalVisibleRows * width;

    const realContainerWidth =
        containerWidth -
        (check ? BULK_ACTIONS_WIDTH : 0) -
        (visibleRows.alarm ? ALARM_WIDTH : 0);

    const currentWidth =
        totalWidth < realContainerWidth
            ? `${realContainerWidth / totalVisibleRows}px`
            : width;

    const arrayElements = [...Array(size)];

    return (
        <Fragment>
            {arrayElements.map((_, index) => {
                return (
                    <TableRow hover key={index} ref={containerRef}>
                        {check && smallTableCell(index)}

                        {hasAlarm && smallTableCell(index)}

                        {rows.map((row) => {
                            if (row === 'alarm') return false;
                            if (visibleRows[row])
                                return (
                                    <TableCell
                                        style={{
                                            padding: 5,
                                            height: 30,
                                            width: currentWidth,
                                        }}
                                        key={row}
                                        width={currentWidth}
                                        data-testid={`skeleton-table-row-${row}-${index}`}
                                    >
                                        <Skeleton
                                            variant="rect"
                                            height={height}
                                        />
                                    </TableCell>
                                );
                            return false;
                        })}
                    </TableRow>
                );
            })}
        </Fragment>
    );
};

export default SkeletonTable;
